/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openquestionsfootnotesaria3Inputs */

const en_openquestionsfootnotesaria3 = /** @type {(inputs: Openquestionsfootnotesaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Related events`)
};

const pt_openquestionsfootnotesaria3 = /** @type {(inputs: Openquestionsfootnotesaria3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos relacionados`)
};

/**
* | output |
* | --- |
* | "Related events" |
*
* @param {Openquestionsfootnotesaria3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const openquestionsfootnotesaria3 = /** @type {((inputs?: Openquestionsfootnotesaria3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openquestionsfootnotesaria3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openquestionsfootnotesaria3(inputs)
	return pt_openquestionsfootnotesaria3(inputs)
});
export { openquestionsfootnotesaria3 as "openQuestionsFootnotesAria" }